import { Tab, Tabs } from 'react-bootstrap';
import { DebugInfoOm } from './debugInfoOm';
import { DebugInfoPc } from './debugInfoPc';
import { DebugInfoNalog } from './debugInfoNalog';
import DEPLOY_INFO from '../../../../deploy-info';
import { DebugInfoBff } from './debugInfoBff';
import { useDispatch, useSelector } from 'react-redux';
import { setMockResponse } from '../../../../app/store/debug/actions';
import { AppState } from '../../../../app/store/rootReducers';
import ToggleButton from '../../toggle-button/ToggleButton';

export const DebugContent = () => {
  const dispatch = useDispatch();
  const mockValue = useSelector((state: AppState) => state.debug.data.mockResponse);

  const sendRequest = async (value: boolean) => {
    try {
      dispatch(setMockResponse(value));
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <div className="mb-3">
        <ToggleButton onClick={() => sendRequest(!mockValue)} checked={mockValue}>
          Mock request
        </ToggleButton>
      </div>
      <Tabs defaultActiveKey="OM" className="mb-3">
        <Tab eventKey="Webshop" title="Webshop">
          <p>
            Branch: <strong>{DEPLOY_INFO.branchName}</strong>
          </p>
          <p>
            Deployed At: <strong>{DEPLOY_INFO.deployedAt}</strong>
          </p>
        </Tab>
        <Tab eventKey="Nalog" title="Nalog">
          <DebugInfoNalog />
        </Tab>
        <Tab eventKey="BFF" title="BFF">
          <DebugInfoBff />
        </Tab>
        <Tab eventKey="OM" title="OM">
          <DebugInfoOm />
        </Tab>
        <Tab eventKey="PC" title="PC">
          <DebugInfoPc />
        </Tab>
      </Tabs>
    </>
  );
};
